import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedBrand: "",
  selectedModel: "",
  selectedYear: "",
};

const carFilterSlice = createSlice({
  name: "carFilter",
  initialState,
  reducers: {
    setBrand: (state, action) => {
      state.selectedBrand = action?.payload;
    },
    setModel: (state, action) => {
      state.selectedModel = action?.payload;
    },
    setYear: (state, action) => {
      state.selectedYear = action?.payload;
    },
  },
});

export const { setBrand, setModel, setYear } = carFilterSlice.actions;
export default carFilterSlice.reducer;
